import axios from "axios";
import { storeAction } from "../storeActions.constant";
import { storeGetters } from "../storeGetters.constant";
import { storeMutation } from "../storeMutations.constant";
import { getBasicHeaders } from "../../common/utils/utils";
import { forumUserInfo } from "../store.constant";
import { addTagsAndImages, makeForumToolkitObjects } from "../../components/ForumPage/ForumConstants";
import { wrapAction } from "../../common/utils/actionLifecycle";
import { toolKitConstants } from "../../components/ChapterPage/communityCommon.constant";

const forumPageState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        forumBaseURL: process.env.VUE_APP_FORUM_BASE_URL,
        forumToolKitList: [],
        forumToolKitListContent: [],
        forumSampleandAgendas: [],
        forumToolKitListExercise: [],
        forumObjectState: [],
        forumQuickLinks: [],
    };
};

const forumPageMutations = {
    [storeMutation.setForumQuickLinks]: (state, data) => {
        state.forumQuickLinks = data;
    },
    [storeMutation.setToolKitList]: (state, data) => {
        const newData = data.filter(d => d.name !== toolKitConstants.CASE_STUDY);
        state.forumToolKitList = addTagsAndImages(newData);
        state.forumObjectState = makeForumToolkitObjects(newData);
    },

    [storeMutation.setToolKitListContent]: (state, data) => {
        state.forumToolKitListContent = data;
    },

    [storeMutation.setToolKitExercise]: (state, data) => {
        state.forumToolKitListExercise = data;
    },
    [storeMutation.setSampleForumContent]: (state, data) => {
        state.forumSampleandAgendas = data;
    },
    [storeMutation.setListState]: (state, data) => {
        const newData = state.forumObjectState.map(p =>
            (p.name === data.name
                ? {
                    ...p,
                    timeRange: data.timeRange,
                    topic: data.topic,
                    materials: data.materials,
                }
                : p));
        state.forumObjectState = newData;
    },
    [storeMutation.setAllListState]: (state) => {
        state.forumObjectState = makeForumToolkitObjects(state.forumToolKitList);
    },
};

const forumPageActions = {
    [storeAction.getForumPageToken]: ({ state }) => {
        const promise = axios({
            url: `${state.forumBaseURL}rest/v1/login?`,
            data: forumUserInfo,
            headers: getBasicHeaders(),
            method: 'GET',
        }).then((response) => {
            return response;
        });
        return promise;
    },

    [storeAction.getForumQuickLinks]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/get-forum-resource-links`,
            headers: getBasicHeaders(),
            method: "GET",
        }).then((response) => {
            commit(storeMutation.setForumQuickLinks, response.data);
            return response.data;
        });
    },

    [storeAction.getForumToolKitListContent]: wrapAction(
        storeAction.getForumToolKitListContent,
        ({ state, commit }) => {
            return axios({
                // url: '/mocks/ForumToolKitListContent.json',
                url: `${state.baseURL}forum/api/v2/exercise/get-all-exercises-optional-parameters`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setToolKitListContent, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getForumToolKitList]: wrapAction(
        storeAction.getForumToolKitList,
        ({ state, commit }) => {
            return axios({
                // url: '/mocks/ForumToolKit.json',
                url: `${state.baseURL}forum/api/exercise/get-types`,
                headers: getBasicHeaders(),
                method: "GET",
            })
                .then((response) => {
                    commit(storeMutation.setToolKitList, response.data);
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),

    [storeAction.getForumToolKitExercises]: ({ state }, exerciseId) => {
        return axios({
            url: `${state.baseURL}forum/api/v2/exercise/get-exercise/${exerciseId}`,
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                return err;
            });
    },

    [storeAction.getForumSampleandAgendas]: ({ commit }) => {
        return axios({
            url: "/mocks/ForumandSampleAgendas.json",
            // url: 'https://ps-forumapi.ypowpo.org/rest/v1/exercises/get-types',
            headers: getBasicHeaders(),
            method: "GET",
        })
            .then((response) => {
                commit(storeMutation.setSampleForumContent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
};

const forumPageGetters = {
    [storeGetters.forumToolKitList]: state => state.forumToolKitList,
    [storeGetters.forumToolKitListContent]: state => state.forumToolKitListContent,
    [storeGetters.forumSampleandAgendas]: state => state.forumSampleandAgendas,
    [storeGetters.forumToolKitListExercise]: state => state.forumToolKitListExercise,
    [storeGetters.forumObjectState]: state => state.forumObjectState,
    [storeGetters.forumQuickLinks]: state => state.forumQuickLinks,
};

export default {
    namespaced: true,
    state: {
        initialState: forumPageState(),
        ...forumPageState(),
    },
    mutations: { ...forumPageMutations },
    actions: { ...forumPageActions },
    getters: { ...forumPageGetters },
};
